import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import styles from "./index.module.scss";
import AppCtrl from "../../../control/AppCtrl";
import Config from "../../../utils/Config";
import LANGUAGE_TYPE from "../../../utils/Language";
import EFunction from "../../../utils/FunctionPage";
import switchFunc from "../../../redux/switchFunc/switchFuncAction";
import useUserCoins from "../../../redux/userCoins/userCoinsAction";
import useAlert from "../../../hook/useAlert";

function StorePage() {
  const text = Config.text.storePage;
  const { setFunc } = switchFunc();
  const { userCoins } = useUserCoins();
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  //===========================================================================
  const [userAccount, setUserAccount] = useState(null);

  useEffect(() => {
    componentDidMount();
    return componentWillUnmount;
  }, []);
  useEffect(() => {
    const language = AppCtrl.getLanguage();
    const userInfo = AppCtrl.userInfo();
    const uiStoreUserName = document.getElementById("storeUserName");
    if (uiStoreUserName) {
      if (language == LANGUAGE_TYPE.en_US)
        uiStoreUserName.innerHTML = `User: ${userInfo.nickName()}`;
      else uiStoreUserName.innerHTML = `用戶: ${userInfo.nickName()}`;
    }
    setUserAccount(userInfo.Account);
    const uiStoreUserAccount = document.getElementById("storeUserAccount");
    if (uiStoreUserAccount) {
      if (language == LANGUAGE_TYPE.en_US)
        uiStoreUserAccount.innerHTML = `Account: ${userInfo.Account}`;
      else uiStoreUserAccount.innerHTML = `帳號: ${userInfo.Account}`;
    }
    if (userCoins) {
      // show coins data
      const uiStoreUserScores = document.getElementById("storeUserScores");
      if (uiStoreUserScores && userCoins.coins != null) {
        const gold = Config.gold[language];
        uiStoreUserScores.innerHTML = `${gold}: ${userCoins.coins.toString()}`;
      }
    }
  }, [userCoins]);
  //===========================================================================

  function componentDidMount() {
    window.addEventListener("resize", onResize);
    onResize();
    
    const userInfo = AppCtrl.userInfo();
    const uiStoreBuyScores = document.getElementById("storeBuyScores");
    const showBuyScores = Config.showBuyScores; // 直接使用布林值
    const useStore = userInfo.UserUseStoreState === 2; // 直接比較並保留布林結果
    const displayStyle = (showBuyScores && useStore) ? "" : "none";
    if (uiStoreBuyScores)
      uiStoreBuyScores.style.display = displayStyle;
  }

  function componentDidUpdate() {}

  function componentWillUnmount() {
    window.removeEventListener("resize", onResize);
  }

  function onResize() {
    const deviceWidth = window.innerWidth;
    const deviceHeight = window.innerHeight;

    const uiStorePage = document.getElementById("storePage");
    if (uiStorePage) {
      uiStorePage.style.height = `${deviceHeight}px`;
      uiStorePage.style.overflowY = "auto";
    }
  }

  function onBack() {
    //AppCtrl.askMachineTokenInLobby();
    setFunc(EFunction.winLobby);
    // navigate('/lobby');
  }

  function onRefreshUserScores() {
    AppCtrl.getUserScores();
  }

  function onBuyScores() {
    const language = AppCtrl.getLanguage();
    const mainSettings = AppCtrl.mainSettings();
    const userInfo = AppCtrl.userInfo();
    if (mainSettings.VerifyUserInfo && !userInfo.Verified) {
      setFunc(EFunction.verifyPhone);
      // navigate('/verify-phone');
      if (language == LANGUAGE_TYPE.en_US)
        showAlert({ title: "Verify account to enjoy more benefit." });
      // AppCtrl.alert("Verify account to enjoy more benefit.");
      else showAlert({ title: "驗證帳號能享受更多遊戲權利。" });
      // AppCtrl.alert("驗證帳號能享受更多遊戲權利。");
    } else if (userInfo.Blocked) {
      if (language == LANGUAGE_TYPE.en_US)
        showAlert({ title: "You had been blocked." });
      // AppCtrl.alert("You had been blocked.");
      else showAlert({ title: "玩家被停權。" });
      // AppCtrl.alert("玩家被停權。");
    } else if (
      userInfo.InCoins - userInfo.OutCoins >=
      userInfo.MaxBuyableScore
    ) {
      if (userInfo.MaxBuyableScore > 0) {
        if (language == LANGUAGE_TYPE.en_US)
          showAlert({
            title: `Your scores is larger than ${userInfo.MaxBuyableScore}, no need to purchase more scores`,
          });
        // AppCtrl.alert(`Your scores is larger than ${userInfo.MaxBuyableScore}, no need to purchase more scores`);
        else
          showAlert({
            title: `玩家目前分數高於${userInfo.MaxBuyableScore}，不需要再購買分數。`,
          });
        // AppCtrl.alert(`玩家目前分數高於${userInfo.MaxBuyableScore}，不需要再購買分數。`);
      } else {
        if (language == LANGUAGE_TYPE.en_US)
          showAlert({ title: `Your level is not able to purchase scores` });
        // AppCtrl.alert(`Your level is not able to purchase scores`);
        else showAlert({ title: `玩家目前等級不能購買分數。` });
        // AppCtrl.alert(`玩家目前等級不能購買分數。`);
      }
    } else {
      if (Config.urlBuyScores) {
        window.open(`${Config.urlBuyScores}?account=${AppCtrl.getAccount()}`);
      } else {
        alert(`null Config.urlBuyScores`);
      }
    }
  }

  return (
    <div id="storePage" className={styles.storePage}>
      <div className={styles.mainArea}>
        <div>
          <h3>{`${text.store}`}</h3>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              textAlign: "left",
              fontSize: "18px",
              width: "100%",
              height: "120px",
              color: "white",
            }}
          >
            <div
              style={{ margin: "0px 10px", width: "60%", textAlign: "left" }}
            >
              <div id="storeUserName"></div>
              <div id="storeUserAccount"></div>
              <div id="storeUserScores"></div>
            </div>
            <div
              style={{ margin: "0px 10px", width: "40%", textAlign: "right" }}
            >
              <button
                className="large red button"
                style={{
                  margin: "5px auto",
                  width: "100%",
                  height: "50px",
                  maxWidth: "160px",
                  fontSize: "16px",
                }}
                onClick={onBack}
              >{`${text.back}`}</button>
              <button
                className="large green button"
                style={{
                  margin: "5px auto",
                  width: "100%",
                  height: "50px",
                  maxWidth: "160px",
                  fontSize: "16px",
                }}
                onClick={onRefreshUserScores}
              >{`${text.refresh}`}</button>
            </div>
          </div>
          <hr></hr>
        </div>
        <div id="storeBuyScores">
          <h3>{`${text.buyScores}`}</h3>
          <div style={{ margin: "10 auto", height: "40px" }}>
            <button
              className="blue button"
              style={{ width: "35%", fontSize: "18px", textAlign: "center" }}
              onClick={onBuyScores}
            >{`${text.confirm}`}</button>
          </div>
          <hr></hr>
        </div>
      </div>
    </div>
  );
}

export default StorePage;
